<template>
  <div class="optWrap">
    <button v-if="processType=='NORMAL' && !experimentFlag" class="docOption" @click="editProcess">수정모드</button>
    <button v-if="processType=='NORMAL'" class="docOption" @click="updateStatus({'readOnlyDocumentOption':true})">문서정보</button>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import CommNew , {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import Loading from '@common/loading.vue'
import {v4} from "uuid";

export default {
  data () {
    return {
      crntProtocol : null,
      loading : false,
      isConnectUser : false,
    }
  },
  mixins:[ CommNew ] , 
  components : {
    Loading
  } ,
  props: {
    processType : {
      type : String,
      default : null
    },
    experimentFlag : {
      type : Boolean,
      default : false
    },
  },
  async mounted () {

  } ,
  watch: {
    '$route.query.processId': {
      async handler() {

      },
    },
  },
  computed : {
  } ,
  methods : {
    ...commNewMapMutations([
      'updateStatus' , 
    ]) ,
    editProcess(){
      /*전체링크 수정모드*/
      this.$emit('editProcess') ;
    },
  } , 
  
}
</script>

<style lang="scss" scoped>
  @import "@/style/new/css/cyl.common.css";

  .optWrap {
    --gap: 8px; 
    --size: 32px; 
    position: fixed; bottom:320px; right:20px;
    display: flex; 
    // flex-wrap: wrap; 
    width: 125px; 
    gap: var( --gap ); 
    z-index: 92;
    transition: transform 0.3s ease;
    transform: translateX(calc(var( --nodeinfo-width ) * -1 )); 
    justify-content: end; 

    .publishWrap{
      position:absolute;
      right:0;
      bottom:40px;
      width: 125px;
      
      >button{
        display: flex; 
        border: 1px solid #6C79A8; 
        width: 100%; 
        height: var( --size ); 
        justify-content: center; 
        align-items: center; 
        font-size: 14px; 
        color: $gray-3; 
        flex-shrink: 0; 
        @include text-prt-sb;    
        background-color: #F0F6FF;
        &:after {
          content:'';
          display: inline-block; width:14px; height: 14px;
          margin-right: 5px;
          background: url('@/assets/icons/icon-publish.svg') center no-repeat;
        }        
      }
      >.publishStatus{
        display:flex;
        justify-content: flex-end;
        align-items: center;
        padding-bottom:5px;
        @include text-prt-sb;    
        font-size:14px;
        >span{
          display:block;
          width:10px;height:10px;
          border-radius:50%;
          margin-right:5px;
        }
      }
    }
    &.move {
      transform: translateX( 0 ); 
    }
    > button , > a {
      display: flex; 
      border: 1px solid $gray-d; 
      width: 100%; 
      height: var( --size ); 
      justify-content: center; 
      background-color: #fff;
      align-items: center; 
      font-size: 14px; 
      color: $gray-3; 
      flex-shrink: 0; 
      @include text-prt-sb; 
      &.docOption {
        width: calc( 100% - var( --size ) - var( --gap )); 
      } 
      &.historyList {
        font-size: 0; 
        background: url('@/assets/icons/clock.svg') no-repeat center center #fff; 
        width: 32px; 
        flex-shrink: 0; 
      }
      &.historySave {
        background-color: $gray-e; 
      }
    }
  }

  .wikiViewerPopup {
    @include modalLayoutBlur;
    
  }

  .alertPopup {
			display: flex; align-items: center; justify-content: center;
			/*position: fixed; top:0; left:0; right:0; bottom:0;*/
			.layout {
				padding: 24px;
				border: 1px solid #999;
				background: #fff;
			}
			z-index: 5;
			.title {
				margin-bottom: 6px;
			}
			.content {
				font-size: 12px;
				line-height: 24px;
				color: #999;
			}
			.buttons-wrap {
				display: flex; justify-content: center; gap: 8px;
				margin-top: 14px;
			}
		}
</style>